import FontFaceObserver from 'fontfaceobserver';

import log from '../services/logger_service';

const fonts = [
  'Beckett',
  'CentraNo2',
  'CentraNo2Book',
  'GrifitoL',
  'GrifitoM',
  'Grifo'
];
export default class FontLoaderUtil {
  static loadFonts() {
    const fontPromise = Promise.all(
      fonts.map(function observeFont(fontname) {
        return new FontFaceObserver(fontname);
      })
    );
    return fontPromise
      .then(function fontLoadSuccess() {
        document.documentElement.className +=
          document.documentElement.className === ''
            ? 'fonts-loaded'
            : ' fonts-loaded';
      })
      .catch(function fontLoadFail(err) {
        document.documentElement.className +=
          document.documentElement.className === ''
            ? 'fonts-loaded fonts-loaded-error'
            : ' fonts-loaded fonts-loaded-error';
        log.error(err, 'Error in font loader loading fonts.');
      });
  }
}
